import { Injectable } from "@angular/core";
import { Observable, tap } from "rxjs";
import { environment } from "../../environments/environment";
import { ErrorConstants } from "../constants/error_constants";
import { HttpClient } from "@angular/common/http";
import { ErrorService } from "../services/error-service.service";
import { ApiResponseModel, HttpService } from "../services/http-service";
import { Lead } from "../models/lead";


@Injectable({
    providedIn: 'root',
})

export class LeadApi {

    constructor(
        private http: HttpClient,
        private httpService: HttpService,
        private errorService: ErrorService
    ) { }

    createLead(lead: Lead): Observable<ApiResponseModel> {
        const url = `${environment.url}lead/absa/create/`;

        const request = {
            lead: lead
        };

        this.errorService.setError(ErrorConstants.CREATE_LEAD);

        return this.http.post<ApiResponseModel>(url, request).pipe(
            this.httpService.formatApiResponse()
        );
    }

    updateLead(lead: Lead, identifier: any): Observable<Response> {
        let url = environment.url + "lead/absa/" + identifier + "/update/";

        this.errorService.setError(ErrorConstants.UPDATE_LEAD);

        return this.http.post<Response>(url, { lead: lead })
            .pipe(tap({
                next: (event: any) => {
                    return this.httpService.formattedResponse(event);
                },
                error: (error: any) => {
                    return this.httpService.formattedResponse(error);
                }
            }));
    }

    getUniqueLinkEducationalInstitution(unique_id: any): Observable<Response> {

        let url = environment.url + "api_admin/educational_institutions/unique_link_ei/";

        this.errorService.setError(ErrorConstants.GET_UNIQUE_LINK_EI);

        const request = {
            ei_unique_id: unique_id,
        }

        return this.http.post<Response>(url, request)
            .pipe(tap({
                next: (event: any) => {
                    return this.httpService.formattedResponse(event);
                },
                error: (error: any) => {
                    return this.httpService.formattedResponse(error);
                }
            }));
    }

    getEducationalInstitutionsFromGroup(unique_id: any): Observable<Response> {
        let url = environment.url + "api_admin/educational_institutions/education_group/institutions/";

        this.errorService.setError(ErrorConstants.GET_EI_FROM_GROUP);

        const request = {
            unique_id: unique_id,
        }

        return this.http.post<Response>(url, request)
            .pipe(tap({
                next: (event: any) => {
                    return this.httpService.formattedResponse(event);
                },
                error: (error: any) => {
                    return this.httpService.formattedResponse(error);
                }
            }));
    }
    // This uses elastic search, only use if really needed
    searchEducationalInstitutions(name: string, filter_partner_school: boolean): Observable<Response> {
        let url = environment.url + "api_admin/educational_institutions/search/";

        this.errorService.setError(ErrorConstants.SEARCH_EI);

        const request = {
            name: name,
            filter_partner_school: filter_partner_school,
            env: 'absa'
        };

        return this.http.post<Response>(url, request)
            .pipe(tap({
                next: (event: any) => {
                    return this.httpService.formattedResponse(event);
                },
                error: (error: any) => {
                    return this.httpService.formattedResponse(error);
                }
            }));
    }

    sendAbsaLinkEmail(lead: Lead, link: string): Observable<Response> {
        let url = environment.url + "api_admin/notifications/absa_send_link/";

        this.errorService.setError(ErrorConstants.SEND_LINK_EMAIL);

        const request = {
            lead: lead,
            link: link
        };

        return this.http.post<any>(url, request).pipe(tap({
            next: (event: any) => {
                return this.httpService.formattedResponse(event);
            },
            error: (error: any) => {
                return this.httpService.formattedResponse(error);
            }
        }));
    }
}